module.exports = __webpack_public_path__ + "static/media/Tahmid.e4982de3.jpg";